import * as types from '../mutation-types'

const state = {
  search: '',
  types: []
}

const mutations = {
  [types.UPDATE_SEARCH] (state, payload) {
    state.search = payload
  },
  [types.ADD_TYPE] (state, payload) {
    if (state.types.indexOf(payload) === -1) {
      state.types.push(payload)
    }
  },
  [types.REMOVE_TYPE] (state, payload) {
    let index = state.types.indexOf(payload)
    if (index !== -1) {
      state.types.splice(index, 1)
    }
  },
  [types.UPDATE_TYPES] (state, payload) {
    state.types = payload
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filters.js